// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-card {
  background: white;
  border-radius: 20px;
  padding: 24px;
  text-align: center;
  box-shadow: var(--shadow);
  position: relative;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.word-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.word-card.large {
  padding: 40px;
}

.word-card.large .word-english {
  font-size: 48px;
}

.word-card.large .word-polish {
  font-size: 28px;
}

.word-english {
  font-size: 32px;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 8px;
}

.word-polish {
  font-size: 20px;
  color: var(--text-light);
}

.speak-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 44px;
  height: 44px;
  border: none;
  background: var(--accent);
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: transform 0.2s, background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.speak-btn:hover {
  transform: scale(1.1);
  background: #1976D2;
}

.type-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: var(--secondary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* Word breakdown dictionary for sentences */
.word-breakdown {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 2px dashed #e0e0e0;
  text-align: left;
}

.breakdown-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-light);
  margin-bottom: 10px;
}

.breakdown-words {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.breakdown-item {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  background: #f5f5f5;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 13px;
}

.breakdown-en {
  font-weight: 600;
  color: var(--primary);
}

.breakdown-pl {
  font-size: 11px;
  color: var(--text-light);
}

.word-card.large .word-breakdown {
  margin-top: 24px;
}

.word-card.large .breakdown-item {
  padding: 8px 14px;
  font-size: 15px;
}

.word-card.large .breakdown-pl {
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/WordCard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".word-card {\n  background: white;\n  border-radius: 20px;\n  padding: 24px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  position: relative;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.word-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.word-card.large {\n  padding: 40px;\n}\n\n.word-card.large .word-english {\n  font-size: 48px;\n}\n\n.word-card.large .word-polish {\n  font-size: 28px;\n}\n\n.word-english {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--primary);\n  margin-bottom: 8px;\n}\n\n.word-polish {\n  font-size: 20px;\n  color: var(--text-light);\n}\n\n.speak-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 44px;\n  height: 44px;\n  border: none;\n  background: var(--accent);\n  border-radius: 50%;\n  font-size: 20px;\n  cursor: pointer;\n  transition: transform 0.2s, background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.speak-btn:hover {\n  transform: scale(1.1);\n  background: #1976D2;\n}\n\n.type-badge {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  background: var(--secondary);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Word breakdown dictionary for sentences */\n.word-breakdown {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 2px dashed #e0e0e0;\n  text-align: left;\n}\n\n.breakdown-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-light);\n  margin-bottom: 10px;\n}\n\n.breakdown-words {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n}\n\n.breakdown-item {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  background: #f5f5f5;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.breakdown-en {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.breakdown-pl {\n  font-size: 11px;\n  color: var(--text-light);\n}\n\n.word-card.large .word-breakdown {\n  margin-top: 24px;\n}\n\n.word-card.large .breakdown-item {\n  padding: 8px 14px;\n  font-size: 15px;\n}\n\n.word-card.large .breakdown-pl {\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
